import * as api from '~/api'
import { BOOKING } from '~/utils/urlApi';

export const getMedicalBill = (baseUrl, data) =>
  // api.postHttpRequestAsync(`${baseUrl}/booking/getbyuserid`, data)
  api.postHttpRequestAsync(`${baseUrl}${BOOKING.GETBYUSERID_URL}`, data)
